import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@ncoder/ui';
import { TrainingProgressBar, TrainingMetric } from '../../atoms/training/TrainingMetric';

interface TrainingProgressProps {
  progress: number;
  epochsCompleted: number;
  totalEpochs: number;
  timeRemaining: string;
}

export const TrainingProgress: React.FC<TrainingProgressProps> = ({
  progress,
  epochsCompleted,
  totalEpochs,
  timeRemaining,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Training Progress</CardTitle>
        <CardDescription>Monitor your agent's training progress</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <TrainingProgressBar progress={progress} />
        <div className="grid grid-cols-2 gap-4 text-sm">
          <TrainingMetric 
            label="Epochs Completed" 
            value={`${epochsCompleted} / ${totalEpochs}`} 
          />
          <TrainingMetric 
            label="Est. Time Remaining" 
            value={timeRemaining} 
          />
        </div>
      </CardContent>
    </Card>
  );
};
